module.exports = __webpack_public_path__ + "static/media/Ios4.2afed85c.png";